import { render, staticRenderFns } from "./SafetyManagerManage.vue?vue&type=template&id=8c5cbe24&"
import script from "./SafetyManagerManage.vue?vue&type=script&lang=js&"
export * from "./SafetyManagerManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports